module Meevo.Components.Controls {

    export enum BenefiteTemplateUpdateItemTypeEnum {
        ProductOverall = 1,
        ServiceOverall = 2,
        PackageOverall = 3,
        ProductItem = 4,
        ServiceItem = 5,
        PackageItem = 6
    }

    export interface ItemMarketListItem {
        value: number;
        itemId: string;
        objectState: number;
        homeLocationId: number;
        displayName: string;
        isDefault?: boolean;
        isPercent: boolean;
        priceGroupId: string;
    }

    export interface ItemMarketModalOptions {
        data: ItemMarketListItem[];
        displayName: string;
        memberBenefitTemplateId: string;
        itemShortcut: string;
        isPercentOnly?: boolean;
        selectedItemId?: string;
        updateType: BenefiteTemplateUpdateItemTypeEnum;
    }

    export class ItemMarketsController {
        static $inject = [
            "meevo.AppSettings",
            "$mdDialog",
            "meevo.components.common.DataService",
            "options",
            "meevo.components.modal.ModalService",
            "meevo.components.common.SecurityService",
        ];

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            private $mdDialog: angular.material.IDialogService,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private options: ItemMarketModalOptions,
            private modalService: Meevo.Components.Modal.IModalService,
            private securityService: Meevo.Components.Common.ISecurityService) {
        }

        isPriceEditDisabled: boolean;

        securityKeys = Meevo.Components.Common.SecurityKeys;
        securityParts = Meevo.Components.Common.SecurityParts;

        $onInit() {
            this.securityService.checkSecurityItem(this.securityKeys.MANAGEMENT_MARKETPRICING_TAB_MEMBERBENEFITTEMPLATES + this.securityParts.KEY_PART_WRITE).then(result => {
                this.isPriceEditDisabled = result.securityAccess != Model.SecurityAccessEnum.Grant;
            });
        }

        closeModal(e): void {
            if (e) e.stopPropagation();

            this.$mdDialog.hide();
        }

        applyChanges(e): void {
            if (e) e.stopPropagation();

            this.modalService.yellowConfirm('MESSAGE_PRICE_MANAGEMENT_SAVE_CHANGES', Meevo.Components.Modal.ModalTranslationModes.Translate, true)
                .then((res: boolean) => {

                    if (res !== true)
                        return;

                    switch (this.options.updateType) {
                        case BenefiteTemplateUpdateItemTypeEnum.PackageItem: {
                            this.updateItemPriceOverrides("Package");

                            break;
                        }
                        case BenefiteTemplateUpdateItemTypeEnum.ProductItem: {
                            this.updateItemPriceOverrides("Product");

                            break;
                        }
                        case BenefiteTemplateUpdateItemTypeEnum.ServiceItem: {
                            this.updateItemPriceOverrides("Service");

                            break;
                        }
                        case BenefiteTemplateUpdateItemTypeEnum.PackageOverall: {
                            this.updateOverallDiscounts(this.options.data.map(row => {
                                return {
                                    priceGroupId: row.priceGroupId,
                                    packageDiscount: row.value
                                }
                            }));

                            break;
                        }
                        case BenefiteTemplateUpdateItemTypeEnum.ProductOverall: {
                            this.updateOverallDiscounts(this.options.data.map(row => {
                                return {
                                    priceGroupId: row.priceGroupId,
                                    productDiscount: row.value
                                }
                            }));

                            break;
                        }
                        case BenefiteTemplateUpdateItemTypeEnum.ServiceOverall: {
                            this.updateOverallDiscounts(this.options.data.map(row => {
                                return {
                                    priceGroupId: row.priceGroupId,
                                    serviceDiscount: row.value
                                }
                            }));

                            break;
                        }

                    }

                });
        }

        updateItemPriceOverrides(itemEndpointSegment: string) {
            this.dataService.customMethodData("api/MemberBenefitTemplate/" + this.options.memberBenefitTemplateId + "/MarketPricing/" + itemEndpointSegment, "PUT", {
                itemId: this.options.selectedItemId,
                values: this.options.data.map(row => {
                    return {
                        priceGroupId: row.priceGroupId,
                        discountAmount: row.value,
                        isPercent: row.isPercent
                    }
                })
            }).then(() => {
                this.closeModalWithValue();
            });
        }

        updateOverallDiscounts(values: any) {
            this.dataService.customMethodData("api/MemberBenefitTemplate/" + this.options.memberBenefitTemplateId + "/MarketPricing/Overall", "PUT", {
                values: values
            }).then(() => {
                this.closeModalWithValue();
            });
        }

        closeModalWithValue() {
            const defaultMarket = this.options.data.find((item) => item.isDefault)

            this.$mdDialog.hide({
                defaultMarket
            });
        }

    }

    angular.module("meevo.components.controls")
        .controller("meevo.components.controls.marketPricing.ItemMarketsController", ItemMarketsController);
}